import type { ChatWidgetTranslation } from './types';

export const chatWidgetAr: ChatWidgetTranslation = {
  nav: 'نافذة المحادثة',
  title: 'نافذة المحادثة',
  description:
    'كيف تبدو المحادثة على موقعك وكيف تعمل، وما تسأله للعملاء، وكيف تشاركها. يُحفظ كل تبويب وحده، وتصل التغييرات إلى المواقع خلال دقيقة.',
  loading: 'جارٍ تحميل إعدادات نافذة المحادثة',
  brand: 'العلامة التجارية',
  open: 'نافذة المحادثة',
  openLabel: 'إعدادات نافذة المحادثة لـ {{name}}',
  noPermission: 'لا يسمح دورك بتغيير نافذة المحادثة. اطلب ذلك من مالك مساحة العمل أو مديرها.',
  forbidden: {
    title: 'لا يمكنك تغيير نافذة المحادثة',
    description: 'اطلب من مالك مساحة العمل أو مديرها دورًا يسمح بإعداد نافذة المحادثة.',
  },
  noBrands: {
    title: 'لا توجد علامة تجارية بعد',
    description: 'أضف علامة تجارية وموقعها أولًا، ثم أعدّ محادثتها هنا.',
    action: 'انتقل إلى العلامات التجارية والتثبيت',
  },
  tabs: {
    label: 'أجزاء المحادثة',
    look: 'المظهر',
    behaviour: 'السلوك',
    forms: 'النماذج',
    privacy: 'الخصوصية',
    share: 'المشاركة',
  },
  unsaved: 'لديك تغييرات لم تُحفظ.',
  reset: 'تراجع عن التغييرات',
  guideLook: 'كيف تغيّر المظهر',
  preview: {
    note: 'صورة للمحادثة بتغييراتك قبل الحفظ. لتجربة المحادثة الحقيقية، استخدم «اختبار المحادثة» في صفحة العلامات التجارية والتثبيت.',
    language: 'اللغة',
    screen: 'اعرض',
    screens: {
      prechat: 'قبل بدء المحادثة',
      offline: 'نموذج التواصل',
      thanks: 'بعد الإرسال',
    },
    prechatOff: 'نموذج ما قبل المحادثة متوقف: يبدأ العملاء المحادثة مباشرة.',
    offlineOff: 'نموذج التواصل متوقف: يمكن للعملاء الكتابة رغم ذلك وقراءة الرد عند عودتهم.',
    consentOff: 'طلب الموافقة متوقف: لا يُطلب من أحد الموافقة قبل المحادثة.',
    layout: 'على موقعك: {{layout}}، {{side}}.',
  },
  behaviour: {
    title: 'كيف تعمل المحادثة',
    description:
      'أين تظهر المحادثة، وما يمكن للعملاء إرساله والعثور عليه، والرسائل التي تصلهم بالبريد.',
  },
  forms: {
    guide: 'كيف تعمل النماذج',
    save: 'حفظ النماذج',
    saved: 'حُفظت النماذج لـ {{name}}. تصل إلى المواقع خلال دقيقة.',
    prechat: {
      title: 'قبل بدء المحادثة',
      description:
        'اسأل بعض الأسئلة قبل أن تبدأ المحادثة، ليرد الشخص المناسب وبين يديه ما يحتاجه. كل سؤال إضافي يعني عملاء أقل يبدؤون المحادثة.',
      enabled: 'اطرح هذه الأسئلة قبل بدء المحادثة',
      enabledHint: 'عند إيقافه، يبدأ العملاء الكتابة مباشرة.',
      skipVerified: 'تخطَّ الأسئلة للعملاء الذين سجّل موقعك دخولهم',
      skipVerifiedHint: 'أخبرنا موقعك بهويتهم مسبقًا، فينتقلون إلى المحادثة مباشرة.',
    },
    offline: {
      title: 'عندما لا يتوفر من يرد',
      description:
        'بدل الانتظار، يترك العملاء رسالة. تصبح الرسالة تذكرة في صندوق الوارد، ويصل الرد إلى بريدهم بعد أن يؤكدوا العنوان.',
      enabled: 'اعرض نموذج تواصل عندما لا يتوفر من يرد',
      enabledHint: 'عند إيقافه، يمكن للعملاء الكتابة في المحادثة رغم ذلك وقراءة الرد عند عودتهم.',
      when: 'متى يظهر',
      whens: {
        either: 'خارج ساعات العمل، أو عندما لا يكون أحد متصلًا',
        eitherHint: 'لا ينتظر العملاء أبدًا دون أن يعرفوا أنه لا يوجد أحد.',
        closed: 'خارج ساعات العمل فقط',
        closedHint: 'يحتاج إلى ساعات العمل. بدونها لا يظهر النموذج أبدًا.',
        nobody_online: 'فقط عندما لا يكون أحد من الفريق متصلًا',
        nobody_onlineHint: 'وكذلك خلال ساعات العمل، عندما يكون الجميع بعيدين أو غير متصلين.',
      },
      thanks: 'رسالة الشكر',
      thanksHint:
        'ما يقرؤه العملاء بعد الإرسال. إذا تُركت فارغة تُستخدم كلمات Hamnivo (تظهر باهتة). تعرض اللغات الأخرى النص الإنجليزي حتى تكتبها.',
      aiFirst: 'دع المساعد الذكي يرد أولًا',
      aiFirstHint: 'يحاول المساعد الذكي الرد على الرسالة، ويتابع الفريق عندما يسلّم التذكرة.',
      emailLocked: 'يُطلب دائمًا وإلزامي: يصل الرد إلى العميل على هذا العنوان.',
      questionLocked: 'يُطلب دائمًا وإلزامي: هذا ما يرد عليه فريقك.',
      lockedRemove: 'لا يعمل نموذج التواصل دون هذا السؤال.',
    },
    fields: {
      legend: 'الأسئلة',
      count: '{{n}} من {{max}} أسئلة',
      empty: 'لا توجد أسئلة بعد. أضف سؤالًا، أو أوقف هذا النموذج.',
      field: 'السؤال {{number}}: {{name}}',
      kind: 'نوع الإجابة',
      kinds: {
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        question: 'سؤال العميل',
        department: 'الفريق المطلوب',
        text: 'نص قصير',
        choice: 'اختيار من قائمة',
      },
      label: 'ما يقرؤه العميل',
      labelHint: 'الإنجليزية مطلوبة. تعرض اللغات الأخرى النص الإنجليزي حتى تكتبها.',
      required: 'يجب على العملاء الإجابة',
      moveUp: 'انقل {{name}} لأعلى',
      moveDown: 'انقل {{name}} لأسفل',
      moved: 'أصبح {{name}} السؤال {{number}}.',
      remove: 'احذف {{name}}',
      removeShort: 'احذف',
      removed: 'حُذف {{name}}.',
      add: 'أضف سؤالًا',
      added: 'أُضيف {{name}} في النهاية.',
      full: 'يمكن للنموذج أن يطرح {{max}} أسئلة على الأكثر. احذف سؤالًا لتضيف غيره.',
      options: 'الإجابات المتاحة للاختيار',
      optionsHint: 'من {{min}} إلى {{max}} إجابات.',
      departmentHint: 'كل إجابة ترسل المحادثة إلى فريق دعم.',
      option: 'الإجابة {{number}}',
      team: 'فريق الإجابة {{number}}',
      teamPlaceholder: 'اختر فريقًا',
      noTeams: 'أضف فريق دعم أولًا: كل إجابة تقود إلى فريق.',
      noTeamsLink: 'انتقل إلى فرق الدعم',
      addOption: 'أضف إجابة',
      removeOption: 'احذف الإجابة {{number}} من {{name}}',
      otherLanguages: 'العربية والهندية والأردية (المكتوب: {{n}} من 3)',
      optionsFull: 'يمكن أن تضم القائمة {{max}} إجابات على الأكثر.',
    },
    problems: {
      at: '{{form}}، السؤال {{number}}',
      label: '{{at}}: اكتب نص السؤال بالإنجليزية.',
      duplicateKind: '{{at}}: هذا النوع من الإجابات مطلوب بالفعل. اطلبه مرة واحدة.',
      fewOptions: '{{at}}: أضف {{min}} إجابات على الأقل.',
      manyOptions: '{{at}}: أضف {{max}} إجابات على الأكثر.',
      optionLabel: '{{at}}: اكتب الإجابة {{option}} بالإنجليزية.',
      optionTeam: '{{at}}: اختر فريق الإجابة {{option}}.',
      tooManyFields: '{{form}}: اطرح {{max}} أسئلة على الأكثر.',
      needsEmail: 'يحتاج نموذج التواصل إلى بريد إلكتروني إلزامي، ليصل الرد إلى العميل.',
      needsQuestion: 'يحتاج نموذج التواصل إلى سؤال العميل إلزاميًا، ليعرف فريقك بماذا يرد.',
      thanksEnglish: 'اكتب رسالة الشكر بالإنجليزية أولًا. تعود إليها اللغات الأخرى.',
      forms: {
        prechat: 'نموذج ما قبل المحادثة',
        offline: 'نموذج التواصل',
      },
    },
  },
  privacy: {
    title: 'الموافقة قبل المحادثة',
    description:
      'اطلب من العملاء الموافقة قبل بدء المحادثة. تُحفظ موافقتهم مع نسخة الكلمات التي وافقوا عليها.',
    guide: 'كيف تعمل الموافقة',
    mode: 'من يُسأل',
    modes: {
      off: 'لا أحد',
      offHint: 'يبدأ العملاء المحادثة مباشرة.',
      everyone: 'كل زائر',
      everyoneHint: 'يوافق الجميع مرة واحدة قبل رسالتهم الأولى.',
      eu: 'الزوار من الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية والمملكة المتحدة فقط',
      euHint: 'نتحقق من مصدر الاتصال في كل زيارة ولا نحفظه أبدًا.',
    },
    text: 'الكلمات التي يوافق عليها العملاء',
    textHint:
      'إذا تُركت فارغة تُستخدم كلمات Hamnivo (تظهر باهتة). تعرض اللغات الأخرى النص الإنجليزي حتى تكتبها.',
    reconsent: 'تغيير الكلمات يطلب من العملاء الذين وافقوا سابقًا أن يوافقوا مرة أخرى.',
    reconsentNow: 'غيّرت الكلمات: بعد الحفظ، يُطلب من العملاء الذين وافقوا سابقًا الموافقة مجددًا.',
    version: 'وافق العملاء على النسخة {{version}} من الكلمات.',
    versionNone: 'لم يوافق أحد بعد: لم تُحفظ هذه الكلمات.',
    privacyLink: 'رابط سياسة الخصوصية',
    privacyLinkHint: 'يظهر مع السؤال. تضبطه في تبويب المظهر.',
    privacyNone: 'لا يوجد رابط لسياسة الخصوصية بعد.',
    privacyEdit: 'غيّره في تبويب المظهر',
    save: 'حفظ إعدادات الموافقة',
    saved: 'حُفظت إعدادات الموافقة لـ {{name}}.',
    english: 'اكتب الكلمات بالإنجليزية أولًا. تعود إليها اللغات الأخرى.',
  },
  share: {
    link: {
      title: 'رابط المحادثة المباشر',
      description:
        'صفحة لا تحوي إلا المحادثة، لمشاركتها في الرسائل وعلى وسائل التواصل أو في المطبوعات.',
      guide: 'كيف يعمل الرابط المباشر',
      enabled: 'اسمح بفتح المحادثة من رابط',
      enabledHint: 'إيقافه ينهي المحادثات التي فُتحت من الرابط.',
      save: 'حفظ إعداد الرابط',
      savedOn: 'رابط المحادثة المباشر يعمل الآن لـ {{name}}.',
      savedOff: 'رابط المحادثة المباشر متوقف الآن لـ {{name}}.',
      url: 'رابط المحادثة',
      copy: 'انسخ الرابط',
      copied: 'نُسخ الرابط',
      copyFailed: 'لم ينجح النسخ. الرابط محدد: انسخه بنفسك.',
      open: 'افتح',
      openLabel: 'افتح رابط المحادثة في علامة تبويب جديدة',
      off: 'الرابط متوقف. شغّله واحفظ لتحصل على الرابط ورمز QR الخاص به.',
      noUrl:
        'لا يمكن إنشاء الرابط بعد: لا يعرف هذا الخادم عنوان المحادثة على الويب. اطلب من الشخص الذي يدير خادم Hamnivo أن يضبطه.',
      anyWebsite: 'يعمل الرابط حتى على المواقع غير الموجودة في قائمة المواقع المسموح بها.',
    },
    qr: {
      title: 'رمز QR',
      description: 'اطبعه على الإيصالات أو العبوات أو الملصقات. تفتح كاميرا الهاتف المحادثة.',
      label: 'رمز QR يفتح محادثة {{name}}',
      download: 'نزّل رمز QR',
      downloaded: 'نُزّل رمز QR.',
      off: 'يظهر رمز QR هنا عندما يعمل الرابط.',
    },
    install: {
      noAccess:
        'يمكن لمن يدير العلامات التجارية نسخ رمز التثبيت من صفحة العلامات التجارية والتثبيت.',
      guides: 'كيف تضع الرمز على موقعك',
    },
  },
};
